import React from 'react';

// Utils
import { useTranslation } from 'react-i18next';
import withAuth from '../../../utils/hocs/withAuth';
import withSidebar from '../../../utils/hocs/withSidebar';
import SCOPE from '../../../utils/gate/scope';
import withPermission from '../../../utils/hocs/withPermission';

// Components
import PageWrapper from '../../../components/layout/PageWrapper/PageWrapper';
import ExtrasView from '../../../components/views/establishment/Products/Extras/Extras';

function Extras() {
  const { t } = useTranslation();

  return (
    <PageWrapper
      title={t('extras.title')}
      hasWhiteWrapper
    >
      <ExtrasView />
    </PageWrapper>
  );
}

export default withAuth(
  withPermission(
    withSidebar(Extras),
    {
      scopes: [SCOPE.get_ownEst_extra],
    },
  ),
);
